import { Button, TextField, DialogContent, DialogTitle, Dialog, DialogActions as MuiDialogActions, DialogActions, Table, TableContainer, Paper, TableRow, TableCell, TableBody, TableHead, IconButton } from '@mui/material'
import { useGetTasks } from 'hooks/useGetTasks'
import React, { useState } from 'react'
import LeadTaskFormWrapper from './LeadTaskForm'
import { Task } from 'interfaces/entities/task.model'
import { toDate } from 'helpers/dateHelper'
import { FaEdit, FaTrash } from 'react-icons/fa'
import TasksAdminService from 'services/admin/tasksService'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'
import { useGetPipelines } from 'hooks/useGetPipelines'

interface LeadTasksProps {
    leadID: string
}

export const LeadTasks = ({ leadID }: LeadTasksProps) => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()
    const { data: tasksResponse } = useGetTasks({ leadID })
    const { data: pipelinesResponse } = useGetPipelines(localStorage.getItem('orgID') || '', 'tasks')

    const [isOpenTaskFormDialog, setIsOpenTaskFormDialog] = useState(false)
    const [selectedTask, setSelectedTask] = useState<Task | null>(null)

    const submitTask = async (task: Task) => {
        console.log('task: ', task)
        try {
            if (task.id) {
                const response = await TasksAdminService.put(task.id, task)
                console.log('response: ', response)
                toast.success('Задача обновлена успешно')
            } else {
                const response = await TasksAdminService.post(task)
                console.log('response: ', response)
                toast.success('Задача создана успешно')
            }
            queryClient.invalidateQueries({ queryKey: ['tasks', { leadID }] })
        } catch (error) {
            console.error('error: ', error)
        } finally {
            setIsOpenTaskFormDialog(false)
        }
    }

    const deleteTask = async (taskID: number) => {
        try {
            if (window.confirm('Вы уверены, что хотите удалить эту задачу?')) {
                const response = await TasksAdminService.delete(taskID)
                console.log('response: ', response)
                toast.success('Задача удалена успешно')
                queryClient.setQueryData(['tasks', { leadID }], (old: any) => {
                    return {
                        ...old,
                        data: old.data.filter((t: Task) => t.id !== taskID)
                    }
                })
            }
        } catch (error) {
            console.error('error: ', error)
        }
    }

    const buildContent = () => {
        if (!tasksResponse || tasksResponse?.count === 0) {
            return <div data-component="lead-tasks" className="text-center mt-6">
                <div >У сделки еще нет задач. Чтобы создать задачу, нажмите на кнопку ниже.</div>
            </div>
        }

        return <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableCell>#</TableCell>
                    <TableCell>Название</TableCell>
                    <TableCell>Статус задачи</TableCell>
                    <TableCell>Дата</TableCell>
                    <TableCell>Ответственный</TableCell>
                    <TableCell>Дата создания</TableCell>
                    <TableCell>Действия</TableCell>
                </TableHead>
                <TableBody>
                    {tasksResponse.rows?.map((task: Task) => (
                        <TableRow key={task.id}>
                            <TableCell>{task.id}</TableCell>
                            <TableCell>{task.title}</TableCell>
                            <TableCell>{t(`task.status.${task.status}`)}</TableCell>
                            <TableCell>{toDate(task.dueDate)}</TableCell>
                            <TableCell>{task.assigneeID}</TableCell>
                            <TableCell>{toDate(task.createdAt)}</TableCell>
                            <TableCell>
                                <IconButton color="info" onClick={() => {
                                    setSelectedTask(task)
                                    setIsOpenTaskFormDialog(true)
                                }}><FaEdit /></IconButton>
                                <IconButton color="error" onClick={() => {
                                    deleteTask(task.id)
                                }}><FaTrash /></IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    }



    return (
        <div data-component="lead-tasks">
            {buildContent()}
            <div className="mt-4">
                <Button variant="outlined" size='small' color="primary" onClick={() => {
                    setIsOpenTaskFormDialog(true)
                }}>
                    Создать задачу
                </Button>
            </div>
            <Dialog fullWidth maxWidth="sm" open={isOpenTaskFormDialog} onClose={() => {
                setIsOpenTaskFormDialog(false)
                setSelectedTask(null)
            }}>
                <DialogTitle className="text-center">{selectedTask ? 'Редактирование задачи' : 'Создание задачи'}</DialogTitle>
                <DialogContent>
                    <LeadTaskFormWrapper onSubmit={submitTask} task={selectedTask} leadID={leadID} />
                </DialogContent>
            </Dialog>
        </div >
    )
}
